import ConfirmSecurityQuestions from './ConfirmSecurityQuestionsContainer';

export default ConfirmSecurityQuestions;